import { v4 as uuidv4 } from 'uuid';

import { IKnmErknmFormSubject } from '../interfaces/IKnmErknmFormSubject';

export const newFormOrganization: IKnmErknmFormSubject = {
  inn: undefined,
  ogrn: undefined,
  position: undefined,
  okveds: undefined,
  addressFns: undefined,
  organizationName: undefined,
  firstOrganizationName: undefined,
  mspCode: undefined,
  mspRegistryDate: undefined,
  checkSubjectResult: null,
  dateCreate: undefined,
  isAutocomplete: undefined,
  isFiz: undefined,
  guid: undefined,
  isDocumentOrganization: false,
  listId: uuidv4(),
  isNew: true,
  nkoForeignAgentsRegistryNumber: undefined,
  nkoForeignAgentsRegistryInclusionDate: undefined,
  nkoForeignAgentsRegistryExclusionDate: undefined,
  isNko: undefined,
  subjectType: undefined,
  kpp: undefined,
  smevRequestStatus: undefined,
  rafpNza: undefined,
  isForeignSubjectAgencyNotRegistredInRf: undefined,
  country: undefined,
  isSonko: undefined,
  locationAddress: undefined,
  workAddress: undefined,
  factualAddress: undefined,
  snils: undefined,
  document: undefined,
  epguNotifications: undefined,
  ervkId: undefined,
  isPresentInItRegistry: undefined,
  itAccreditationResponse: undefined,
  smevItAccreditationRequestStatus: undefined,
  inspectionResults: undefined,
  locationregion: undefined,
  locationnotInFIAS: undefined,
  locationmanualAddress: undefined,
  locationfiasRegion: undefined,
};
